import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem("lux_token")) return setUser(false);
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      localStorage.removeItem("lux_token");
      setUser(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const finish = (data) => {
    localStorage.setItem("lux_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const login = async (email, password) => finish((await api.post("/auth/login", { email, password })).data);
  const register = async (body) => finish((await api.post("/auth/register", body)).data);
  const logout = () => {
    localStorage.removeItem("lux_token");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, register, logout, refresh }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
export const homeFor = (role) => ({ customer: "/customer", driver: "/driver", admin: "/admin", business: "/business" }[role] || "/");
